module.exports = __webpack_public_path__ + "media/bootstrap-icons/caret-down-dbf503a0.svg";